module.exports = __webpack_public_path__ + "img/box7-img-2.238e941d.png";